import Sentry from 'sentry';

global.FHRD = {
    // dry-run marker:
    branch:     'fhrd',
    dry:        true,
    ftype:      0,
    gewerbe:    false,
    mtrl:       0,
    o_possible: true,
    type:       'fhrd',
    usage:      0,
    v_peril:    true,
    v_risk:     true,
    bikes:      [],
    MTRL_STAHL: 'Stahl',
    MTRL_ALU: 'Aluminium',
    MTRL_CARBON: 'Carbon',
    FHRD_TYPE_BIKE: 'Fahrrad',
    FHRD_TYPE_EBIKE: 'E-Bike / Pedelec',
    FHRD_TYPE_CARGOBIKE: 'Lastenrad',

    canCalc: function(e) {
        var bikesThatPassedHaveRisk = this.bikes.filter(function (bike) {
            return FHRD.haveRisk(bike);
        }).length;

        var bikesThatPassedHaveInfo = this.bikes.filter(function (bike) {
            return FHRD.haveInfo(bike.id);
        }).length;

        JQ('#b_' + FHRD.type + '_go2datavn').button("option", "disabled", bikesThatPassedHaveInfo !== this.bikes.length);

        ALL.chgMobButton('#btn_fwd_1', bikesThatPassedHaveInfo !== this.bikes.length);

        PRIV.calcable = bikesThatPassedHaveRisk === this.bikes.length;

        if (PRIV.calcable) {
            JQ('#div_fhrd_dv_1').toggle(true);
        }

        BC.debug('FHRD.canCalc(): ', PRIV.calcable, 64);

        return PRIV.calcable;
    },

    change: function(e) {
        BC.debug('FHRD.change()', '...starting...', 64);
        if (ALL.mobile && ALL.steps[0] >= 4) {
            ALL.chgProduct(FHRD.type, 1);
            ALL.notifyHeight();
            return;
        } else if (!FHRD.canCalc(e)) {
            if (FHRD.haveRisk(FHRD.bikes[0])) {
                return;
            } else {
                ALL.chgProduct(FHRD.type, null);
                ALL.notifyHeight();
                return;
            }
        }
        FHRD.chkDivReady('#div_1');
        FHRD.chkDivReady('#div_2');
        FHRD.recalc();
        ALL.notifyHeight();
    },

    chkDivReady: function(btn) {
        if (moment().format("YYYY") === JQ('[name="fhrd_yprd-0"]').val() && ALL.mobile && ALL.branch === 'fhrd') {
            JQ("#div_da_vv6").hide();
            JQ("#div_da_vv1").hide();
        } else {
            JQ("#div_da_vv6").show();
            JQ("#div_da_vv1").show();
        }

        if (ALL.checkIfBikeProdYearIsCurrentYear()) {
            JQ('#fahrrad-vorversicherung-inputs').css({
                'display': 'none',
            });
        } else {
            JQ('#fahrrad-vorversicherung-inputs').css({
                'display': 'block',
            });
        }
        ALL.notifyHeight();

        var r;
        BC.debug('FHRD.chkDivReady():', btn, 64);
        try {
            var b = BC.get_id(btn);
            var p = ALL.get_box_id(b);
            if (! p) return false;
            var d = BC.get_id(p);
        }
        catch (e) {
            BC.debug('FHRD.chkDivReady() raised an exception:', e, 16);
            Sentry.captureException(e);
            return false;
        }

        if (! d) return false;

        BC.debug('FHRD.chkDivReady() called for ' + b + ' in ' + d, btn, 64);
        ALL.chkDivReady(d, true);

        var ready = 0;
        switch(d) {
            case '#div_0':
                return true;
            case '#div_1':
                ready = this.bikes.filter(function (bike) {
                    return bike.plz.val() && bike.vs.val();
                }).length;
                if (ready === FHRD.bikes.length) {
                    JQ('#f_fhrd_plz2').val(JQ('#f_fhrd_plz').val());
                    ALL.chgMobButton('#btn_fwd_1', true);
                    BC.debug('FHRD.chkDivReady(): ' + d + ' is ready!', '', 64);
                    return true;
                }
                ALL.chgMobButton('#btn_fwd_1', false);
                break;
            case '#div_2':
                FHRD.get_usage();
                ready = this.bikes.filter(function (bike) {
                    return FHRD.get_mtrl(bike.id) && FHRD.get_ftype(bike.id) && FHRD.haveInfo(bike.id);
                }).length;
                if (ready === FHRD.bikes.length) {
                    BC.debug('FHRD.chkDivReady(): ' + d + ' is ready!', '', 64);
                    ALL.steps[1] = 3;
                    ALL.chgMobButton('#btn_fwd_2', true);
                    return true;
                }
                ALL.chgMobButton('#btn_fwd_2', false);
                break;
            case '#div_3':
                if (JQ('#f_' +  FHRD.type + '_zw').val() &&
                        JQ('#f_' +  FHRD.type + '_start').val() &&
                ALL.steps[1] >= 3) {
                ALL.steps[1] = 4;
                BC.debug('FHRD.chkDivReady(): ' + d + ' is ready!', '', 64);
                return true;
                }
                ALL.chgMobButton('#btn_fwd_3', false);
                break;
            case '#div_4':
                    FHRD.setChkFlds();
                r = PRIV.chkDA1();
                if ((JQ('#f_vn_anrede').val() == '1' ||
                    JQ('#f_vn_anrede').val() == '2' ||
                    JQ('#f_vn_anrede').val() == '5')) {

                    JQ('#l_vn_nachname').text("Nachname");
                    JQ('#f_vn_nachname').prop('placeholder', "Nachname");
                    JQ('#f_vn_gebdat').prop('required', true);
                    JQ('#f_vn_vorname').prop('required', true);
                    JQ('#f_vn_gebdat').parent().show();
                    JQ('#f_vn_vorname').parent().show();

                } else if (JQ('#f_vn_anrede').val() === '4') {
                    JQ('#l_vn_nachname').text("Firma");
                    JQ('#f_vn_nachname').prop('placeholder', "Firmenname");
                    JQ('#f_vn_gebdat').prop('required', false);
                    JQ('#f_vn_vorname').prop('required', false);
                    JQ('#f_vn_gebdat').parent().hide();
                    JQ('#f_vn_vorname').parent().hide();
                }
                ALL.notifyHeight();
                if (JQ('#f_vn_anrede').val() === '4') {
                    ALL.haveVN()
                    if (r && ALL.haveVN() && ALL.steps[1] >= 4) {
                        BC.debug('FHRD.chkDivReady(): ' + d + ' is ready!', '', 64);
                        if (b.slice(0, 4) == '#btn') PRIV.get_onr();
                        return true;
                    }
                }
                else if (r && ALL.isVNcompleted() && ALL.haveVN() && ALL.steps[1] >= 4) {
                    BC.debug('FHRD.chkDivReady(): ' + d + ' is ready!', '', 64);
                    if (b.slice(0, 4) == '#btn') PRIV.get_onr();
                    return true;
                }
                break;
            case '#div_5':
                    FHRD.setChkFlds();
                r = PRIV.chkDA2();
                BC.debug('FHRD.chkDivReady(): #div_5 ready is', r, 64);
                if (r) return true;
                BC.debug('FHRD.chkDivReady(): #div_5 is NOT ready!', '', 64);
                //ALL.chgMobButton('#btn_fwd_5', false);
                    break;
            case '#div_98':
                return true;
            case '#div_99':
                    // JQ('#div_'  +  FHRD.type + '_rslt').hide();
                ALL.triggerDataLayerEvent('Fahrrad', FHRD.type);
                return true;
            default:
                BC.debug('FHRD.chkDivReady() switch to default, BAD THING [tm]:', d, 16);
                break;
        }
        BC.debug('FHRD.chkDivReady(): ' + d + ' is NOT ready!', '', 64);
        return false;
    },

    chkKeys: function(e) {
        var plz = JQ('#f_fhrd_plz_0').val();
        var vs = JQ('#f_fhrd_vs_0').val();
        var plzi, vsi;
        BC.debug('FHRD.chkKeys(): key pressed: ' + e.key +
              ' plz.len=' + plz.length + ' vs.len=' + vs.length, '', 64);
        try {
            plzi = parseInt(plz);
            vsi  = parseInt(vs);
        }
        catch(e) {
            BC.debug('FHRD.chkKeys(): raised exception:', e, 64);
            vsi = 0;
            plzi = 0;
        }

        if (plz.length == 5 && plzi > 1000) {
            BC.debug('FHRD.chkKeys(): Moving focus to VS', '', 64);
            JQ('#f_fhrd_vs_0').focus();
        }

        if (! isNaN(plzi) &&
                ! isNaN(vsi) &&
                plz.length == 5 &&
                vs.length == 4 &&
                plzi >= 1000 &&
                plzi <= 99999 &&
                vsi > 999 &&
                vsi <= 9999) {
            BC.debug('FHRD.chkKeys(): 1st calc is possible!', '', 64);
            ALL.chgMobButton('#btn_fwd_1', true);
            FHRD.change();
            return;
        }
        BC.debug('FHRD.chkKeys(): 1st calc is NOT possible!', '', 64);
        ALL.chgProduct(FHRD.type, 0);
        ALL.chgMobButton('#btn_fwd_1', false);
    },

    get_ftype: function(bikeId) {
        BC.debug('FHRD.get_ftype()', '', 64);

        if (JQ('[name="fhrd_ftype-'+ bikeId +'"]:checked').val()) {
            FHRD.ftype = parseInt(JQ('[name="fhrd_ftype-'+ bikeId +'"]:checked').val());
        } else {
            FHRD.ftype = 2;
        }

        if (isNaN(FHRD.ftype)) {
            FHRD.ftype = 0;
        }
        return FHRD.ftype;
    },

    get_mtrl: function(bikeId) {
        BC.debug('FHRD.get_mtrl()', '', 64);

        if (JQ('[name="fhrd_mtrl-'+ bikeId +'"]:checked').val()) {
            FHRD.mtrl = parseInt(JQ('[name="fhrd_mtrl-'+ bikeId +'"]:checked').val());
        } else {
            FHRD.mtrl = 1;
        }

        if (isNaN(FHRD.mtrl)) FHRD.mtrl = 0;
        return FHRD.mtrl;
    },

    get_usage: function() {
        BC.debug('FHRD.get_usage()', '', 64);
        FHRD.usage = parseInt(JQ('#fset_' + FHRD.type + '_risk input[name="' + FHRD.type + '_usage"]:checked').val());
        var gew = FHRD.usage == 2 || FHRD.usage == 3;
        PRIV.bparts['fhrd'] = gew ? ['gew'] : ['prv'];

        // change wording according to usage type (this is the dowload stuff)
        var $wording = JQ('#a_da_wording');
        $wording.attr('href', gew ? $wording.data('dl-gewerbe') : $wording.data('dl-privat'));

        return FHRD.usage;
    },

    handleDirA: function(dirA) {
        if (dirA[0] === 'Für die angegebene Postleitzahl ist kein reiner Diebstahlschutz möglich.') {
            JQ('#f_fhrd_reine_diebstahldeckung_0').click();
        }
    },

    haveInfo: function(bikeId) {
        var bikeKaufDatum = Boolean(JQ('[name="fhrd_kauf-'+ bikeId +'"]').val());
        var bikeYearProd = Boolean(JQ('[name="fhrd_yprd-'+ bikeId +'"]').val());
        //var bikeProducer = Boolean(JQ('[name="fhrd_producer-'+ bikeId +'"]').val());
        //var bikeModel = Boolean(JQ('[name="fhrd_model-'+ bikeId +'"]').val());
        //var bikeFrame = Boolean(JQ('[name="fhrd_frame-'+ bikeId +'"]').val());

        FHRD.o_possible = bikeKaufDatum && bikeYearProd;


            if (! ALL.mobile)
            FHRD.o_possible ? JQ('#a_' + FHRD.type + '_da').show() : JQ('#a_' + FHRD.type + '_da').hide();
        BC.debug('FHRD.haveInfo() => ', FHRD.o_possible , 64);

        return FHRD.o_possible;
    },

    havePeril: function(e) {
        FHRD.v_peril = JQ('#f_' + FHRD.type + '_dv').is(':checked') || ALL.mobile;
        JQ('#div_fhrd_dv_1').toggle(FHRD.v_peril);
        return FHRD.v_peril;
    },

    haveRisk: function(bike) {
        var plz = bike.plz.val();
        var price = bike.vs.val();
        var bikeId = bike.id;

        if (plz && price) {
            BC.debug('FHRD.haveRisk(): Checking ...', '', 64);
            // valid = true : Alle Risikomerkmale vorhanden
            FHRD.v_risk = true;
            var _vs = parseInt(price);
            if (isNaN(_vs)) _vs = 0;
            var _plz = parseInt(plz);
            if (isNaN(_plz)) _plz = 0;
            if (ALL.mobile && !_vs) {
                FHRD.v_risk = false;
                return false;
            } else if (ALL.mobile && _vs && _vs < 1) {
                ALL.showHint('Die Versicherungssumme (=Kaufpreis) des Fahrrads / E-Bikes muss mindestens 1 € betragen.');
                FHRD.v_risk = false;
                ALL.chgMobButton('#btn_fwd_1', false);
            }
            FHRD.get_ftype(bike.id);
            FHRD.get_mtrl(bike.id);
            FHRD.get_usage();
            var _kauf = moment(JQ('[name="fhrd_kauf-'+ bikeId +'"]').val(), 'DD.MM.YYYY');
            var _y = JQ('[name="fhrd_yprd-'+ bikeId +'"]').val();
            var _year = moment('31.12.' + _y, 'DD.MM.YYYY');
            var _startField = JQ('#f_' + FHRD.type + '_start')
            var _start = moment(_startField.val(), 'DD.MM.YYYY');
            var _today = moment().startOf('day');
            if (_vs && _vs < 1) {
                ALL.showHint('Die Versicherungssumme (=Kaufpreis) des Fahrrads / E-Bikes muss mindestens 1 € betragen.');
                JQ('[name="fhrd_vs-'+ bikeId +'"]').val(1)
                FHRD.v_risk = false;
            } else if (_vs && _vs > 12500) {
                ALL.showHint('Die Versicherungssumme des Fahrrads darf höchstens 12.500 € betragen.');
                JQ('[name="fhrd_vs-'+ bikeId +'"]').val(12500)
                FHRD.v_risk = false;
            } else if (_vs < 0 || _vs > 12500) {
                BC.debug('FHRD.haveRisk(): Error with _vs, ftype or usage =>', [_vs, FHRD.ftype, FHRD.usage], 64);
                ALL.showHint('Die Versicherungssumme ' + _vs + ' ist unzulässig.');
                FHRD.v_risk = false;
            }
            if (!_plz) FHRD.v_risk = false;
            if (FHRD.v_risk && (FHRD.ftype < 1 || FHRD.ftype > 4)) {
                //ALL.showHint('Ungültiger Fahrradtyp: ' + ftype);
                FHRD.v_risk = false;
            } else if (FHRD.v_risk && (FHRD.usage < 2 || FHRD.usage > 3) && (FHRD.mtrl < 1)) {
                //ALL.showHint('Fahrräder oder E-Bikes, deren Rahmen nicht aus Stahl oder Aluminium hergestellt wurden, können derzeit leider nicht versichert werden.');
                FHRD.v_risk = false;
            } else if (FHRD.v_risk && (FHRD.usage == 2 || FHRD.usage == 3) && (FHRD.mtrl < 1 || FHRD.mtrl > 3)) {
                // Gewerblich mit unbekanntem Material?!?!
                FHRD.v_risk = false;
            }

            if (_start.isBefore(_today)) {
                _startField.val(_today.format('DD.MM.YYYY'));
                ALL.showHint('Der Versicherungsbeginn darf nicht in der Vergangenheit liegen, das Datum wurde entsprechend angepasst.');
            }

            if (FHRD.v_risk && !isNaN(_year) && parseInt(_y) && _start.diff(_year, 'y', true) > 5) {
                ALL.showHint('Fahrräder oder E-Bikes, die älter als 5 Jahre sind, können nicht versichert werden.');
                JQ('[name="fhrd_yprd-'+bikeId+'"]').val(year);
                FHRD.v_risk = true;
            } else if (FHRD.v_risk && (isNaN(_year) || !parseInt(_y))) {
                FHRD.v_risk = false;
            }
            BC.debug('FHRD.haveRisk(' + FHRD.type + '): =>', [FHRD.v_risk, _vs, _plz, FHRD.ftype, FHRD.mtrl, _kauf, _y, _year, _start], 64);
            JQ('#f_' + FHRD.type + '_dv').prop('disabled', !FHRD.v_risk);

            // fist disable all the relevant fields
            JQ('#f_fhrd_plus_row_privat, #f_fhrd_plus_row_privat2').hide();
            JQ('#f_fhrd_plus_row_gewerblich, #f_fhrd_plus_row_gewerblich2').hide();
            JQ('#f_fhrd_ausschluss_fahraddiebstahl_row, #f_fhrd_ausschluss_fahraddiebstahl_row2').hide();
            JQ('#f_fhrd_familiendiebstahl_row, #f_fhrd_familiendiebstahl_row2').hide();

            // wenn Fahrradnutzung: Privat und Fahrrad, zeige Tarfifauwahl und Abschluss Diebstahl
            if (FHRD.usage === 1 && FHRD.ftype === 1) {
                JQ('#f_fhrd_plus_row_privat, #f_fhrd_plus_row_privat2').show();
                JQ('#f_fhrd_ausschluss_fahraddiebstahl_row, #f_fhrd_ausschluss_fahraddiebstahl_row2').show();
                if (JQ('#f_' + FHRD.type + '_reine_diebstahldeckung_1').is(':checked')) {
                    JQ('#f_' + FHRD.type + '_ausschluss_fahraddiebstahl_row').hide();
                }
                // wenn Fahrradnutzung: Privat und EBike, zeige Tarfifauwahl und Abschluss Diebstahl
            } else if (FHRD.usage === 1 && FHRD.ftype === 2) {
                JQ('#f_fhrd_plus_row_privat, #f_fhrd_plus_row_privat2').show();
                JQ('#f_fhrd_ausschluss_fahraddiebstahl_row, #f_fhrd_ausschluss_fahraddiebstahl_row2').show();
                if (JQ('#f_' + FHRD.type + '_reine_diebstahldeckung_1').is(':checked')) {
                    JQ('#f_' + FHRD.type + '_ausschluss_fahraddiebstahl_row').hide();
                }
                // wenn Fahrradnutzung: Privat und Lastenrad, zeige Tarfifauwahl und Abschluss Diebstahl
            } else if (FHRD.usage === 1 && FHRD.ftype === 3) {
                JQ('#f_fhrd_plus_row_privat, #f_fhrd_plus_row_privat2').show();
                JQ('#f_fhrd_ausschluss_fahraddiebstahl_row, #f_fhrd_ausschluss_fahraddiebstahl_row2').show();
                if (JQ('#f_' + FHRD.type + '_reine_diebstahldeckung_1').is(':checked')) {
                    JQ('#f_' + FHRD.type + '_ausschluss_fahraddiebstahl_row').hide();
                }
                // wenn Fahrradnutzung: Privat und S-Pedelec, zeige Tarfifauwahl und Abschluss Diebstahl
            } else if (FHRD.usage === 1 && FHRD.ftype === 4) {
                JQ('#f_fhrd_plus_row_privat, #f_fhrd_plus_row_privat2').show();
                JQ('#f_fhrd_ausschluss_fahraddiebstahl_row, #f_fhrd_ausschluss_fahraddiebstahl_row2').show();
                if (JQ('#f_' + FHRD.type + '_reine_diebstahldeckung_1').is(':checked')) {
                    JQ('#f_' + FHRD.type + '_ausschluss_fahraddiebstahl_row').hide();
                }
                // wenn nicht Fahrradnutzung: Privat (sollte alle anderen Cases erschlagen)
            } else {
                JQ('#f_fhrd_plus_row_gewerblich, #f_fhrd_plus_row_gewerblich2').show();
                JQ('#f_fhrd_ausschluss_fahraddiebstahl_row, #f_fhrd_ausschluss_fahraddiebstahl_row2').show();
                if (JQ('#f_' + FHRD.type + '_reine_diebstahldeckung_1').is(':checked')) {
                    JQ('#f_' + FHRD.type + '_ausschluss_fahraddiebstahl_row').hide();
                }
            }
            var bikesWithFtypeFahrrad = this.bikes.filter(function (bike) {
                return JQ('[name="fhrd_ftype-'+bike.id+'"]').first().is(':checked');
            }).length;

            var bikesWithFtypeLastenrad = this.bikes.filter(function (bike) {
                return JQ('[name="fhrd_ftype-'+bike.id+'"]').last().is(':checked');
            }).length;

            if ((bikesWithFtypeFahrrad + bikesWithFtypeLastenrad) === 0) {
                JQ('#f_fhrd_familiendiebstahl_row, #f_fhrd_familiendiebstahl_row2').show();
            } else {
                JQ('#f_fhrd_familiendiebstahl_0').click();
                JQ('#f_fhrd_familiendiebstahl_row, #f_fhrd_familiendiebstahl_row2').hide();
            }

            if (FHRD.usage === 2 || FHRD.usage === 3) {
                JQ('#f_fhrd_familiendiebstahl_row, #f_fhrd_familiendiebstahl_row2').hide();
            }

            ALL.notifyHeight();
            return FHRD.v_risk;
        }
    },

    init: function() {
        PRIV.hideLogoutAndAdministration();
        JQ('#f_' + FHRD.type + '_reine_diebstahldeckung_1').click(function () {
            JQ('#f_' + FHRD.type + '_ausschluss_fahraddiebstahl_1').attr('checked', false);
            JQ('#f_' + FHRD.type + '_ausschluss_fahraddiebstahl_0').attr('checked', true);
            JQ('#f_' + FHRD.type + '_ausschluss_fahraddiebstahl_row').hide();
            ALL.notifyHeight();
        });

        JQ('#f_' + FHRD.type + '_reine_diebstahldeckung_0').click(function () {
            JQ('#f_' + FHRD.type + '_ausschluss_fahraddiebstahl_row').show();
            ALL.notifyHeight();
        });

        JQ('#f_' + FHRD.type + '_ausschluss_fahraddiebstahl_1').click(function () {
            JQ('#f_' + FHRD.type + '_reine_diebstahldeckung_1').attr('checked', false);
            JQ('#f_' + FHRD.type + '_reine_diebstahldeckung_0').attr('checked', true);
            JQ('#f_' + FHRD.type + '_reine_diebstahldeckung_row').hide();
            ALL.notifyHeight();
        });

        JQ('#f_' + FHRD.type + '_ausschluss_fahraddiebstahl_0').click(function () {
            JQ('#f_' + FHRD.type + '_reine_diebstahldeckung_row').show();
            ALL.notifyHeight();
        });

        JQ("#f_fhrd_plus_1").click(function () {
            JQ('#f_fhrd_marktgarantie').show()
            JQ('#f_' + FHRD.type + '_reine_diebstahldeckung_0').click();
            JQ('#f_' + FHRD.type + '_reine_diebstahldeckung_row').hide();
            ALL.notifyHeight();
        });

        JQ("#f_fhrd_plus_0").click(function () {
            JQ('#f_fhrd_marktgarantie').hide()
            JQ('#f_' + FHRD.type + '_reine_diebstahldeckung_row').show();
            ALL.notifyHeight();
        });

        var marktgarantieField = JQ('#f_fhrd_marktgarantie');
        JQ("#f_fhrd_usage_1").click(function() {
            JQ('#f_fhrd_reine_diebstahldeckung_1').attr("disabled", false);
            if (JQ("#f_fhrd_plus_1").is(':checked')) {
                marktgarantieField.show()
                JQ('#f_' + FHRD.type + '_reine_diebstahldeckung_row').hide();
            } else {
                JQ('#f_' + FHRD.type + '_reine_diebstahldeckung_row').show();
            }
            ALL.notifyHeight();
        });

        for (var i = 2; i<= 4; i++) {
            JQ("#f_fhrd_usage_"+i).click(function() {
                JQ('#f_fhrd_marktgarantie_0').click();
                marktgarantieField.hide();
                JQ('#f_' + FHRD.type + '_reine_diebstahldeckung_row').show();

                var isBusinessBike = JQ(this).attr('id') === 'f_fhrd_usage_3';

                if (isBusinessBike && JQ('#f_fhrd_reine_diebstahldeckung_1').is(':checked')) {
                    JQ('#f_fhrd_reine_diebstahldeckung_0').click();
                    ALL.showHint('Für Firmenräder ist kein reiner Diebstahlschutz möglich.');
                }

                JQ('#f_fhrd_reine_diebstahldeckung_1').attr("disabled", isBusinessBike);
                ALL.notifyHeight();
            });
        }


        if (ALL.mobile) {
            JQ("#f_fhrd_dnls").click(function () {
               FHRD.recalc();
            });
        }
        JQ('.def-check').each(function (i, e) {
            JQ(e).attr('checked', true);
        })
        JQ('[name="fhrd_kauf-0"]').datepicker({
            defaultDate: '+1d',
            maxDate: '+1w',
            minDate: '-5y',
            showOn: ALL.mobile  ? 'focus' : 'both',
        });
        JQ('[name="fhrd_kauf-0"]').val(today).mask('99.99.9999');
        JQ(document).change(function (e) {
            if (!JQ(e.target).hasClass('fhrd_kauf')) {
                return;
            }
            var input = JQ(e.target);
            var value = input.val().split('.').join('');
            var day = value.substr(0, 2);
            var month = value.substr(2, 2);
            var year = value.substr(4, 4);
            var date = year + '/' + month + '/' + day;

            date = moment.utc(date);
            var now = moment.utc().hour(0).minute(0).second(0).millisecond(0);

            if (parseInt(day) > 31) {
                input.val(now.format('DD.MM.YYYY'));
                ALL.showHint('Ungültiges Datum!');
            }

            if (parseInt(month) > 12) {
                input.val(now.format('DD.MM.YYYY'));
                ALL.showHint('Ungültiges Datum!');
            }

            if (now.diff(date, 'years') >= 5 && !date.add(5, 'years').isSame(now)) {
                input.val(now.format('DD.MM.YYYY'));
                ALL.showHint('Das Kaufdatum kann maximal 5 Jahre in der Vergangenheit liegen, das Kaufdatum wurde entsprechend angepasst.');
            } else if (now.diff(date, 'days') < -6) {
                input.val(now.format('DD.MM.YYYY'));
                ALL.showHint('Das Kaufdatum kann maximal 7 Tage in der Zukunft liegen, das Kaufdatum wurde entsprechend angepasst.');
            }
            ALL.notifyHeight();
        })
        // init the new array data model with the first bike the rest of the bike application handle bikes as array now
        FHRD.bikes = [{
            id: 0,
            plz: JQ('#f_fhrd_plz_0'),
            vs: JQ('#f_fhrd_vs_0'),
            ftype: 2,
            mtrl: 1,
        }]
        if (ALL.mobile && ALL.branch.slice(0, 4) != FHRD.branch) return;
        BC.debug('FHRD.init():', '', 64);
        JQ('#div_fhrd_vers').change(FHRD.change);
        ALL.chgProduct('fhrd', null);
        if (! ALL.mobile) {
            return;
        } else if (! JQ('#div_fhrd_vers').length) {
                return;
        }
        ALL.chgMobButton('#btn_fwd_1', false);
        JQ('#f_fhrd_vs_0').keyup(FHRD.chkKeys);
        JQ('#f_fhrd_plz_0').keyup(FHRD.chkKeys);
        JQ('#f_' + FHRD.type + '_start').val(tomorrow);
        JQ('[name="fhrd_yprd-0"]').val(year);
	    //JQ('#div_4 input').keyup(FHRD.chkKeys);
        JQ('.box input').keyup(ALL.chkDivReady2);
        JQ('#f_rbt_fhrd_acode').keyup(ALL.chk_aCode);
        JQ('#a_da_wording').click(function() {
            PRIV.wd_read=true;
            // Hold the current onr to ensure it is not overwritten by some side effect
            var onr = PRIV.da_onr;
            ALL.chkDivReady('a_da_wording', true);
            ALL.chgMobButtons(ALL.branch);
            PRIV.da_onr = onr;
        });

        JQ('#f_' + FHRD.type + '_start').change(FHRD.adjustDate);
        FHRD.adjustDate();
        ALL.notifyHeight();
    },

    adjustDate: function () {
        BC.debug('FHRD.adjustDate():', [], 64);
        var start = JQ('#f_' + FHRD.type + '_start');
        var end = JQ('#f_' + FHRD.type + '_ende');

        var format = "DD.MM.YYYY";
        var startMoment = moment(start.val(), format);
        var endMoment = moment(end.val(), format);

        var startPlus3y = startMoment.clone().add(3, 'y');
        var minMoment = startMoment.clone().add(1, 'y');
        var minDate = '+1y1d';
        var maxDate = '+2y';

        if (JQ('#f_' + FHRD.type + '_dnls').length && JQ('#f_' + FHRD.type + '_dnls').is(':checked')) {
            minMoment = startPlus3y
            minDate = '+3y1d';
            maxDate = '+4y';
        }

        var maxMoment = minMoment.clone().add(1, 'y');
        var datepickerOptions = {changeMonth: true,
            changeYear: true,
            defaultDate: minDate,
            maxDate: maxDate,
            minDate: minDate,
            showOn: ALL.mobile  ? 'focus' : 'both',
        }

        BC.debug('FHRD.adjustDate(): Dates', {'minimumDate': minMoment, 'maximumDate': maxMoment, 'start': startMoment, 'end': endMoment}, 64);

        if (endMoment.isBefore(minMoment) || endMoment.isAfter(maxMoment)) {
            BC.debug('FHRD.adjustDate(): Date is changed.', {'minimumDate': minMoment, 'maximumDate': maxMoment, 'start': startMoment, 'end': endMoment}, 64)
            end.val(minMoment.format(format));
        }

        BC.debug('FHRD.adjustDate(): adjusting datepicker widget.', datepickerOptions, 64);

        // adjusting the date picker here to ge a visual feedback for the allowed values.
        // previously the value just silently reset.
        end.datepicker("destroy");
        end.datepicker(datepickerOptions);
        ALL.notifyHeight();
    },

    recalc: function() {
        BC.debug('FHRD.recalc():', [], 64);
        if (! FHRD.canCalc()) {
            BC.debug('FHRD.recalc():', 'Cannot calc - check logs!', 16);
            return;
        }
        var sa = PRIV.make_sa(FHRD.type);
        BC.debug('FHRD.recalc():', sa, 64);

        var bikesWithFtypeFahrrad = this.bikes.filter(function (bike) {
            return JQ('[name="fhrd_ftype-'+bike.id+'"]').first().is(':checked');
        }).length;

        sa.map(function (key){
            if (key.name === 'fhrd_familiendiebstahl' && bikesWithFtypeFahrrad > 0){
                key.value = "0"
            }
            return key
        })

        FHRD.adjustDate();
        JQ.getJSON(JSONURI, ALL.createQueryStringForMultipleBikes(sa), PRIV.setPremium);
        ALL.chkContactData();
        },

        reset: function() {
        BC.debug('FHRD.reset()', '...starting...', 256);
        FHRD.change();
    },

    setChkFlds: function () {
        // Belege Felder in "Angaben überprüfen"
        // Aufruf teilweise in ALL.set_HNR
        if (ALL.mobile) {
            function getMaterial(material) {
                switch (material) {
                    case '1':
                        return FHRD.MTRL_STAHL;
                    case '2':
                        return FHRD.MTRL_ALU;
                    case '3':
                        return FHRD.MTRL_CARBON;
                    default:
                        return 'N/A'
                }
            }

            function getType(type) {
                switch (type) {
                    case '1':
                        return FHRD.FHRD_TYPE_BIKE;
                    case '2':
                        return FHRD.FHRD_TYPE_EBIKE;
                    default:
                        return 'N/A'
                }
            }

            this.bikes.forEach(function (bike, i) {
                JQ('[data-name="pbike-summary-plz-'+ i +'"]').text(JQ('[name="fhrd_plz-'+ i +'"]').val());
                JQ('[data-name="pbike-summary-vs-'+ i +'"]').text(JQ('[name="fhrd_vs-'+ i +'"]').val() + ' €');
                JQ('[data-name="pbike-summary-kauf-'+ i +'"]').text(JQ('[name="fhrd_kauf-'+ i +'"]').val());
                JQ('[data-name="pbike-summary-yprd-'+ i +'"]').text(JQ('[name="fhrd_yprd-'+ i +'"]').val());
                JQ('[data-name="pbike-summary-producer-'+ i +'"]').text(JQ('[name="fhrd_producer-'+ i +'"]').val() || "Bitte ergänzen");
                JQ('[data-name="pbike-summary-model-'+ i +'"]').text(JQ('[name="fhrd_model-'+ i +'"]').val() || "Bitte ergänzen");
                JQ('[data-name="pbike-summary-frame-'+ i +'"]').text(JQ('[name="fhrd_frame-'+ i +'"]').val() || "Bitte ergänzen");
                JQ('[data-name="pbike-summary-mtrl-'+ i +'"]').text(getMaterial(JQ('[name="fhrd_mtrl-'+ i +'"]:checked').val()));
                JQ('[data-name="pbike-summary-ftype-'+ i +'"]').text(getType(JQ('[name="fhrd_ftype-'+ i +'"]:checked').val()));
            })

            JQ('#m098_plz').text(JQ('#f_fhrd_plz').val());
            // JQ('#m098_vs').text(JQ('#f_fhrd_vs').val() + ' €');
            var _usage = JQ('input[type=radio][name=fhrd_usage]:checked').val();
            // var _ftype = JQ('input[type=radio][name=fhrd_ftype]:checked').val();
            // var _mtrl = JQ('input[type=radio][name=fhrd_mtrl]:checked').val();
            JQ('#m098_usage').text(JQ('#l_fhrd_usage_' + _usage).children().first().text());
            // JQ('#m098_ftype').text(JQ('#l_fhrd_ftype_' + _ftype).children().first().text());
            // JQ('#m098_mtrl').text(JQ('#l_fhrd_mtrl_' + _mtrl).children().first().text());
            // JQ('#m098_kauf').text(JQ('#f_fhrd_kauf').val());
            // JQ('#m098_yprd').text(JQ('#f_fhrd_yprd').val());
            JQ('#m098_producer').text(JQ('#f_fhrd_producer').val());
            JQ('#m098_model').text(JQ('#f_fhrd_model').val());
            JQ('#m098_frame').text(JQ('#f_fhrd_frame').val());

            var _plus = JQ('input[type=radio][name=fhrd_plus]:checked').val();
            var _ausschluss_fahraddiebstahl = JQ('input[type=radio][name=fhrd_ausschluss_fahraddiebstahl]:checked').val();
            var _reine_diebstahldeckung = JQ('input[type=radio][name=fhrd_reine_diebstahldeckung]:checked').val();
            var _familendiebstahl = JQ('input[type=radio][name=fhrd_familiendiebstahl]:checked').val();
            var _marktgarantie = JQ('input[type=radio][name=fhrd_marktgarantie]:checked').val();
            var _sb = JQ('select[name=fhrd_rabattoptionen] option:selected').val();
            var _dnls = JQ('input[type=checkbox][name=fhrd_dnls]').is(':checked');

            JQ('#m098_plus').text(_plus === '1' ? 'PremiumPlus' : 'Premium');
            JQ('#m098_marktgarantie').text(_marktgarantie === '1' && _plus === '1' ? 'Die Marktgarantie ist versichert' : '-')
            JQ('#m098_rabattoptionen').text(_sb === '1' ? '150,00 €' : '-');
            JQ('#m098_dnls').text(_dnls ? 'Ja' : 'Nein');

            JQ('#m098_ausschluss_diebstahl').text(_ausschluss_fahraddiebstahl === '1' ? 'Ja' : 'Nein');
            JQ('#m098_reine_diebstahldeckung').text(_reine_diebstahldeckung === '1' ? 'Ja' : 'Nein');
            JQ('#m098_familiendiebstahl').text(_familendiebstahl === '1' ? 'Ja' : 'Nein');

            ALL.setChkFlds(FHRD.type);
            ALL.notifyHeight();
        }
    },

    setPremium: function(data) {
        BC.debug('FHRD.setPremium():', data, 64);
        ALL.chkError(data);
        if (data.ERROR) {
            return;
        }
        JQ.each(data, function(key, val) {
            BC.debug('FHRD.setPremium(0): ' + key + ' = ', val, 64);
            if (key == 'DirA' && val && val.length) {
                PRIV.setDirAnfrage(val);
                return;
            }
            if (JQ('#f_' + FHRD.type + '_' + key).length) {
                BC.debug('FHRD.setPremium(1): ' + key + ' = ', val, 64);
                JQ('#f_' + FHRD.type + '_' + key).text(val.str);
            }
            if (key == 'mpr2' && val.val) {
                JQ('#l_' + FHRD.type + '_net2').text('Jährliche Nettoprämie Fahrradversicherung (Mindestprämie!):');
            } else if (key == 'mpr2') {
                JQ('#l_' + FHRD.type + '_net2').text('Jährliche Nettoprämie Fahrradversicherung:');
            }
            if (key == 'brt1' && val.str) {
                ALL.chgProduct(FHRD.type, val.str);
            }
        });
    },
};
